export default __webpack_public_path__ + "static/media/296.20a4e69b.png";